import React, { useEffect, useRef, useState } from "react";
import { ABtn, AResult, AScore } from "./arcadeUi";

// Charge the throw, then keep the top spinning by tapping in rhythm.
export default function SpinningTop() {
  const [phase, setPhase] = useState("charge"); // charge | spin | over
  const [power, setPower] = useState(0);
  const [rpm, setRpm] = useState(0);
  const [best, setBest] = useState(0);
  const charging = useRef(false);
  const chargeRaf = useRef(null);
  const spinTimer = useRef(null);

  const startCharge = () => {
    if (phase !== "charge") return;
    charging.current = true;
    const grow = () => { if (!charging.current) return; setPower((p) => Math.min(100, p + 2.5)); chargeRaf.current = requestAnimationFrame(grow); };
    chargeRaf.current = requestAnimationFrame(grow);
  };
  const release = () => {
    if (phase !== "charge" || !charging.current) return;
    charging.current = false; cancelAnimationFrame(chargeRaf.current);
    setPhase("spin"); setRpm(power);
    spinTimer.current = setInterval(() => {
      setRpm((r) => {
        const nr = r - 1.1;
        if (nr <= 0) { clearInterval(spinTimer.current); setPhase("over"); setBest((b) => Math.max(b, elapsed.current)); return 0; }
        return nr;
      });
      elapsed.current += 0.1;
    }, 100);
  };
  const elapsed = useRef(0);

  const sustain = () => { if (phase === "spin") setRpm((r) => Math.min(100, r + 6)); };

  const reset = () => { setPhase("charge"); setPower(0); setRpm(0); elapsed.current = 0; };
  useEffect(() => () => { cancelAnimationFrame(chargeRaf.current); clearInterval(spinTimer.current); }, []);

  return (
    <div className="w-full select-none text-center">
      <div className="flex justify-center gap-2">
        <AScore label="Spin time" value={`${elapsed.current.toFixed(1)}s`} />
        <AScore label="Best" value={`${best.toFixed(1)}s`} />
      </div>
      <p className="my-2 text-sm text-kirana-brown/70">Hold to wind the string, release to spin. Then tap the top to keep it going!</p>

      <div className="relative mx-auto my-4 flex h-40 w-40 items-center justify-center">
        <div data-testid="top-spinner" onClick={sustain} className="relative cursor-pointer">
          <div className="relative" style={{ animation: phase === "spin" && rpm > 0 ? `lattoo-spin ${Math.max(0.12, 1.15 - rpm / 110)}s linear infinite` : "none" }}>
            <div className="relative h-24 w-24 rounded-full border-4 border-[#5c3d22] shadow-lg"
              style={{ background: "conic-gradient(#E63946 0deg 60deg,#F4A261 60deg 120deg,#E9C46A 120deg 180deg,#2A9D8F 180deg 240deg,#457B9D 240deg 300deg,#6A0572 300deg 360deg)" }}>
              <div className="absolute left-1/2 top-1/2 h-4 w-4 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#5c3d22]" />
            </div>
            <div className="absolute left-1/2 top-full h-0 w-0 -translate-x-1/2 border-x-[10px] border-t-[16px] border-x-transparent border-t-[#5c3d22]" />
            <div className="absolute left-1/2 top-0 h-3 w-3 -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#8B5A2B]" />
          </div>
        </div>
        <span className="absolute -bottom-3 h-2 w-24 rounded-full bg-black/20 blur-[2px]" />
      </div>

      {phase === "charge" && (
        <>
          <div className="mx-auto mb-3 h-3 w-full max-w-xs overflow-hidden rounded-full border-2 border-kirana-brown bg-kirana-cream">
            <div className="h-full bg-kirana-red" style={{ width: `${power}%` }} data-testid="top-power" />
          </div>
          <ABtn data-testid="top-charge" onPointerDown={(e) => { e.preventDefault(); startCharge(); }} onPointerUp={release} onPointerLeave={release} tone="red" className="px-8 py-3">
            Hold to Wind • Release to Spin
          </ABtn>
        </>
      )}
      {phase === "spin" && <p data-testid="top-rpm" className="font-signboard text-lg text-kirana-brown">Spinning! Tap the top to sustain — {Math.round(rpm)}%</p>}
      {phase === "over" && (
        <>
          <AResult testId="top-result" win={elapsed.current >= 4} text={`Your top spun for ${elapsed.current.toFixed(1)}s`} />
          <div className="mt-3 flex justify-center"><ABtn data-testid="top-again" onClick={reset} tone="green">Spin Again</ABtn></div>
        </>
      )}
    </div>
  );
}
